import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=b50caa66&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=b50caa66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50caa66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b50caa66')) {
      api.createRecord('b50caa66', component.options)
    } else {
      api.reload('b50caa66', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=b50caa66&scoped=true&", function () {
      api.rerender('b50caa66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21iSCZ0pmKba4/JS/comp/PopupBox.vue"
export default component.exports